import ModalCustom from "components/ModalCustom"
import { ReactComponent as IconGoogleAuthen } from "assets/images/icons/google-authen.svg"
import Button from "components/Button/Button"
import { NAME_LOCALSTORAGE } from "constants/localStorage"

interface Props {
  onTryItNowOrganization: () => void
  onCloseModal: () => void
}
export const WarningNewOrganizationModal = (props: Props) => {
  const { onTryItNowOrganization, onCloseModal } = props
  const onRemindMeLater = () => {
    localStorage.setItem(NAME_LOCALSTORAGE.NEW_ORGANIZATION, "true")
    onCloseModal()
  }
  const renderHeader = () => {
    return (
      <div className="flex">
        <p className="text-[16px] text-[#222222] font-semibold">
          🎉 New Feature: Workspaces
        </p>
      </div>
    )
  }

  const renderBody = () => {
    return (
      <div className="flex flex-col">
        <p className="text-[14px] text-[#222222] leading-[24px]">
          We’ve just launched <b>Workspaces</b> — a powerful way to manage your
          teams and workspaces.
        </p>
        <div className="flex flex-col ml-[24px]">
          <p className="text-[14px] text-[#222222] leading-[24px] mt-[12px]">
            — Create and manage multiple workspaces or departments.
          </p>
          <p className="text-[14px] text-[#222222] leading-[24px] mt-[12px]">
            — Add members, assign roles, and control permissions easily.
          </p>
          <p className="text-[14px] text-[#222222] leading-[24px] mt-[12px]">
            — Keep your data and projects organized in one place.
          </p>
        </div>
        <p className="text-[14px] text-[#222222] leading-[24px] mt-[12px]">
          This feature is designed to help teams collaborate and scale
          efficiently.
        </p>
        <div className="flex flex-col md:flex-row gap-y-3 md:gap-y-0 justify-between mt-[16px]">
          <Button
            widthBtn={"100%"}
            title="Remind me later"
            colorBtn="white"
            onClick={onRemindMeLater}
          />
          <Button
            widthBtn={"100%"}
            title="Try it now"
            onClick={onTryItNowOrganization}
          />
        </div>
      </div>
    )
  }
  return (
    <ModalCustom
      label="Enhance security with two-factor authentication"
      widthModal={470}
      styleHeaderModal={{
        height: "auto",
        paddingTop: 12,
        alignItems: "start",
      }}
      renderHeader={renderHeader()}
      bodyChildren={renderBody()}
    />
  )
}
